export default "__VITE_ASSET__xeAUoYRF__"